import { Typography } from '../../designComponents';
import { InfoRowStyled, VerticalSpaceStyled } from '../../style/reusableStyle';

type Props = {
  shippingAddress: string;
};

const ShippingAddress = ({ shippingAddress }: Props) => {
  return (
    <>
      <Typography
        variant="normal"
        strong
        fontColor="secondary"
        className="section-title"
      >
        SHIPPING ADDRESS
      </Typography>
      <VerticalSpaceStyled>
        <InfoRowStyled className="jobInformation">
          <Typography className="title" fontColor="dark">
            Shipping Address :
          </Typography>
          <Typography className="value">{shippingAddress}</Typography>
        </InfoRowStyled>
      </VerticalSpaceStyled>
    </>
  );
};

export default ShippingAddress;
